export const comments_5618859 = {"data":{"data":[],"links":{}}}